import script from "./QuotesView.vue?vue&type=script&setup=true&lang=js"
export * from "./QuotesView.vue?vue&type=script&setup=true&lang=js"

import "./QuotesView.vue?vue&type=style&index=0&id=fb04b276&lang=css"

const __exports__ = script;

export default __exports__